module.exports = __webpack_public_path__ + "img/image (9).67c9f0a0.png";